import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { translate, groupBy, enumText, isNullOrEmpty, enumColor } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';
import InventoryService from '../../../../services/InventoryService';
import LotItemReading from './LotItemReading';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import PieChart from "../../../../components/Chart/PieChart";
import BarChart from "../../../../components/Chart/BarChart";

const InventoryGeneralMonitoring = (props) => {
    const [dataPieChart, setDataPieChart] = useState([]);
    const [dataGroupUser, setDataGroupUser] = useState([]);
    const [dataBarChart, setDataBarChart] = useState([]);
    const [dataColor, setDataColor] = useState([]);
    const [reading, setReading] = useState([]);

    const groupLotByUser = () => {
        const lotInventory = props.lots?.items?.find((l) => l.id === props.filter.inventoryId);
        const lots = lotInventory?.lots;
        const lotsGrouped = groupBy(lots.filter((i) => i.lockedName !== null), 'lockedName');
        const lotData = [];
        lotsGrouped.map((group) => {
            lotData.push([
                group.key,
                group.value.filter((i) => i.status === ENUMS.eInventoryLotStatus.Finished.value).length,
                group.value.filter((i) => !isNullOrEmpty(i.startedBy)).length]);
            return group;
        });
        setDataGroupUser(lotData);
    };

    const groupLotByOrigind = () => {
        const lotsGrouped = groupBy(props.inventory.lots, 'lotOriginId');
        const lotData = [];
        lotsGrouped.map((group) => {
            lotData.push([
                translate(enumText(ENUMS.eInventoryOriginCount, group.key), 'inventory'),
                group.value.filter((i) => i.status === ENUMS.eInventoryLotStatus.Canceled.value).length,
                group.value.filter((i) => i.status === ENUMS.eInventoryLotStatus.InProgress.value).length,
                group.value.filter((i) => i.status === ENUMS.eInventoryLotStatus.Loaded.value).length,
                group.value.filter((i) => i.status === ENUMS.eInventoryLotStatus.Finished.value).length,
                group.value.length
            ]);
            return group;
        });
        setDataBarChart(lotData);
    };

    useEffect(() => {
        if (props.inventory) {
            groupInventoryLot();
            groupLotByOrigind();
        }

        if (props.inventory.lots?.length > 0) {
            groupLotByUser();
        }
        // eslint-disable-next-line
    }, [props.inventory]);

    useEffect(() => {
        const filter = {};
        Object.assign(filter, props.filter);
        filter.pageSize = 10;
        props.getItemsReading(filter);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.lotItemsMonitoringReading && props.lotItemsMonitoringReading.length > 0) {
            setReading([...props.lotItemsMonitoringReading])
        }
        // eslint-disable-next-line
    }, [props.lotItemsMonitoringReading]);

    const groupInventoryLot = () => {
        const lotsGrouped = groupBy(props.inventory.lots, 'status').sort((a, b) => a + b);
        const lotData = [];
        colorPierChart(lotsGrouped);
        lotsGrouped.map((group) => {
            lotData.push([
                translate(enumText(ENUMS.eInventoryLotStatus, group.key), 'inventory'),
                group.value.length]);
            return group;
        });
        setDataPieChart(lotData);
    };

    const colorPierChart = (group) => {
        if (group) {
            const array = [];
            group.forEach((data) => {
                if (data) {
                    array.push({ color: enumColor(ENUMS.eInventoryLotStatus, data.key) });
                }
            });
            setDataColor(array);
        }
    };

    const titleInventoryGeneralMonitoring = { icon: "mdi mdi-clipboard-check-outline", label: translate('inventory:inventory') };

    const subtitlesInventoryGeneralMonitoring = () => {
        return [{ label: props.inventory.code }, { icon: "mdi mdi-chart-bar-stacked", label: translate('inventory:general.menu.monitoring') }];
    }

    const dataChartPie = {
        labels: dataPieChart.map(d => d[0]),
        datasets: [
            {
                data: dataPieChart.map(d => d[1]),
                backgroundColor: dataColor.map(d => d.color)
            }
        ]
    }

    const dataChartBar = {
        labels: ['Desatribuido', 'Mobile'],
        datasets: [
            {

                label: translate(enumText(ENUMS.eInventoryLotStatus, ENUMS.eInventoryLotStatus.Loaded.value), 'inventory'),
                data: dataBarChart.map(d => d[1]),
                backgroundColor:
                    ENUMS.eInventoryLotStatus.Loaded.color
            },
            {
                label: translate(enumText(ENUMS.eInventoryLotStatus, ENUMS.eInventoryLotStatus.Canceled.value), 'inventory'),
                data: dataBarChart.map(d => d[2]),
                backgroundColor:
                    ENUMS.eInventoryLotStatus.Canceled.color

            },
            {
                label: translate(enumText(ENUMS.eInventoryLotStatus, ENUMS.eInventoryLotStatus.InProgress.value), 'inventory'),
                data: dataBarChart.map(d => d[3]),
                backgroundColor:
                    ENUMS.eInventoryLotStatus.InProgress.color
            },
            {
                label: translate(enumText(ENUMS.eInventoryLotStatus, ENUMS.eInventoryLotStatus.Finished.value), 'inventory'),
                data: dataBarChart.map(d => d[4]),
                backgroundColor:
                    ENUMS.eInventoryLotStatus.Finished.color
            },
            {
                label: translate('general.total'),
                data: dataBarChart.map(d => d[5]),
                backgroundColor: 'gray'
            }
        ]
    }

    const dataChartUserBar = {
        labels: dataGroupUser.map(d => d[0]),
        datasets: [
            {
                label: translate(enumText(ENUMS.eInventoryLotStatus, ENUMS.eInventoryLotStatus.Finished.value), 'inventory'),
                axis: 'y',
                data: dataGroupUser.map(d => d[1]),
                backgroundColor: 'rgb(76, 175, 80)'
            },
            {
                label: translate('general.attributed'),
                axis: 'y',
                data: dataGroupUser.map(d => d[2]),
                backgroundColor: '#597dda',
            }
        ]
    }

    return (
        <div>
            <Breadcrumbs id="inventoryGeneralMonitoring" title={titleInventoryGeneralMonitoring} subtitles={subtitlesInventoryGeneralMonitoring()} />
            <div className="container-fluid" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12 m7 l8 xl9">
                        <div className="col s12 m12 l6 xl6">
                            <div className="card">
                                <div className="card-content">
                                    <span className="card-title">{translate('inventory:general.lots')}</span>
                                    <PieChart chartData={dataChartPie} />
                                </div>
                            </div>
                        </div>
                        <div className="col s12 m12 l6 xl6">
                            <div className="card">
                                <div className="card-content">
                                    <span className="card-title">{translate('inventory:general.evolution')}</span>
                                    <BarChart chartData={dataChartBar} indexAxis='x' />
                                </div>
                            </div>
                        </div>
                        <div className="col m12 hide-on-med-and-down">
                            <div className="card">
                                <div className="card-content">
                                    <span className="card-title">{translate('inventory:general.evolution-by-manager')}</span>
                                    <BarChart chartData={dataChartUserBar} indexAxis='y' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col s12 m5 l4 xl3">
                        <div className="card">
                            <div className="card-content">
                                <span className="card-title">{translate('inventory:general.last-readings')}</span>
                                <div className="row" style={{ marginBottom: '5px' }}>
                                    <ul className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        {
                                            reading.length > 0 && reading.slice(0, 10).map((item, index) => (
                                                <LotItemReading key={`lir-${index + 1}`} data={item} usersFromElog={props.usersFromElog} />
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        lots: state.inventoryReducer.inventoryList,
        filter: state.inventoryReducer.filter,
        lotItemsMonitoringReading: state.inventoryReducer.lotItemsMonitoringReading,
        inventory: state.inventoryReducer.inventory,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getItemsReading: (filter) => {
            dispatch(InventoryService.getItemsReading(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryGeneralMonitoring)));
